import { Stack, Text, Link } from "@chakra-ui/react";
import React from "react";
import { isArray } from "lodash";
import H5 from "../../Theme/Typography/H5";
import LargeRegular from "../../Theme/Typography/LargeRegular";
import FilmDetails from "./FilmDetails";
import ProducerDetails from "./ProducerDetails";
import LeadCastDetails from "./LeadCastDetails";

export default function ArchiveFilmDetails({ archive, castData,handleCastDrawer, filmData, producerData }) {

  const renderCast = (cast) => {
    const { anothervalue, display } = cast;
    if (!anothervalue?.length) return null;
    return (
      <>
        <H5 as="span" fontSize="16px" fontWeight={700} lineHeight="17.61px">
          {display}
        </H5>{" "}
        {isArray(anothervalue)
          && anothervalue.map((it, index) => (
              <React.Fragment key={index}>
                {it?.link ? (
                  <Link
                    color="blue.500"
                    fontWeight="400"
                    cursor="pointer"
                    wordSpacing="2px"
                  >
                    {it?.full_name || it?.fullname || it?.name}
                    {index < anothervalue.length - 1 && ", "}
                  </Link>
                ) : (
                  <LargeRegular
                    as="span"
                    color="blue.500"
                    cursor="pointer"
                  >
                    {it?.full_name || it?.fullname || it?.name}
                    {index < anothervalue.length - 1 && ", "}{" "}
                  </LargeRegular>
                )}
              </React.Fragment>
            ))}
          {/* // : anothervalue} */}
      </>
    );
  };

  return (
    archive &&
    castData?.length > 0 && (
      <Stack py="0">
        {filmData && <FilmDetails handleCastDrawer={handleCastDrawer} archive={archive} filmData={filmData} />}
        {producerData && <ProducerDetails handleCastDrawer={handleCastDrawer} archive={archive} producerData={producerData} />}
        <LeadCastDetails handleCastDrawer={handleCastDrawer} data={castData} />
        <Text className="wordspacing col-11" px="0" mt={"0px !important"}>
          {castData
            .filter(
              ({ key, anothervalue }) =>
                key !== "leadCast" && key !== "leadCastRest" && key !== "country_of_origin_film" && key !== "language" && anothervalue
            )
            .map((cast, id) => (
              <React.Fragment key={id}>{renderCast(cast)}</React.Fragment>
            ))}
        </Text>
      </Stack>
    )
  );
}
